import { AxiosResponse } from 'axios';

import { SFCCBasket } from '../../models/sfcc-basket';
import { addLocaleToBasketUrl } from '../../utilities/add-locale-to-basket-url';
import { sfccSettings, shopHttp } from '../basket-api';

export const createBasket = async (basketToTransfer?: SFCCBasket): Promise<SFCCBasket> => {
  const url = '/baskets';
  const finalUrl = addLocaleToBasketUrl(url, sfccSettings.shopApiLocale);

  const response = await shopHttp.post<SFCCBasket, AxiosResponse<SFCCBasket>>(
    finalUrl,
    basketToTransfer
  );

  return response.data;
};
